var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLatestBlocksicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.875 10.938 4.47 6.973a.268.268 0 0 1 .013-.478l7.403-3.47a.266.266 0 0 1 .226 0l7.404 3.47c.199.093.206.375.012.478l-7.403 3.965a.266.266 0 0 1-.251 0Z",
    fill: "#8F67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 10.94c.037.02.079.03.12.03V3a.265.265 0 0 0-.113.025l-7.403 3.47a.268.268 0 0 0-.017.476l7.412 3.97Z",
    fill: "#fff",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M12.467 20.45v-8.482c0-.099.054-.19.14-.236l6.934-3.73a.267.267 0 0 1 .392.236v8.234a.268.268 0 0 1-.134.233l-6.933 3.978a.267.267 0 0 1-.4-.232Z",
    fill: "#8F67FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.467 12.879v7.601a.25.25 0 0 0 .374.217l6.967-3.997a.25.25 0 0 0 .09-.09l-7.431-3.731Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.467 20.45v-8.482a.268.268 0 0 0-.141-.236l-6.933-3.73A.267.267 0 0 0 4 8.238v8.234c0 .096.051.185.134.233l6.934 3.978a.267.267 0 0 0 .399-.232Z",
    fill: "#8F67FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M11.466 12.879v7.572a.267.267 0 0 1-.398.232l-6.934-3.978a.27.27 0 0 1-.097-.096l7.43-3.73Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestBlocksicon);
export default __webpack_public_path__ + "static/media/latest-blocks.icon.8dc4aae9.svg";
export { ForwardRef as ReactComponent };